import React from 'react';
import PropTypes, { any } from 'prop-types';

import links from '../../../../config/links';
import Img from '../../../components/Img';
import { drawScheduleTypeIds, sportTypeIds } from '../../../utils/eventConstants';
import { featureGates } from '../../../utils/statsig';

import styles from './scheduleTab.scss';

export const scheduleTypeDescriptions = [
    {
        id: drawScheduleTypeIds.MATCH_SHEET,
        description: 'With match sheets, you can schedule matches by rounds or individually. You can input details like facility and court, or just the date and time. Additionally, filter by date, facility, draw, or any combination of these. Once scheduled and published, your matches will display in order, along with any added facility and court details.',
        linkDescription: 'We recommend this schedule for recreational and club tournaments. Learn more',
        link: links.scheduleTypeArticle,
        enabledSportTypeIds: [sportTypeIds.TENNIS, sportTypeIds.PICKLEBALL],
    },
    {
        id: drawScheduleTypeIds.ORDER_OF_PLAY,
        description: 'With Order of Play scheduling, you get a visual, court-based tool built for the reality of live events. Build a court grid across one or more facilities, then drag-and-drop matches into time slots directly from your draws. Flexible timing modes — Starts At (Fixed Time), Follows, or Not Before — keep courts active and give players reliable match time expectations throughout the day. Once published, players see their schedule in court order, updated day by day.',
        linkDescription: 'We recommend this schedule for higher-level and prize money tournaments, or round robin pool play events. Learn more',
        link: links.orderOfPlayArticle,
        enabledSportTypeIds: [sportTypeIds.TENNIS, sportTypeIds.PICKLEBALL],
    },
    {
        id: drawScheduleTypeIds.NEXT_AVAILABLE,
        description: `With next available scheduling, matches are assigned to courts from a match queue or waitlist, and players are notified via text message about their court assignments. You'll need to create a court grid for each day/facility and select specific draws to start throughout the day. All matches in a draw will then move to the next available queue for court placement. Once draws begin, a live view on the event page will show matches in progress and those waiting to be assigned to a court.`,
        linkDescription: 'We recommend this schedule for large tournaments aiming to maximize court capacity each day. Learn more',
        link: links.scheduleTypeArticle,
        isFeatureFlagged: true,
        featureFlagName: featureGates.NEXT_AVAILABLE_SCHEDULING,
        enabledSportTypeIds: [sportTypeIds.PICKLEBALL],
    },
];

const ScheduleTypeOption = (props) => {
    const {
        selectedScheduleTypeId,
        scheduleType,
        handleScheduleTypeClick,
        'data-testid': dataTestId,
    } = props;

    const onScheduleTypeClick = () => {
        handleScheduleTypeClick(scheduleType);
    };

    return (
        <div
            className={`radio-button noselect ${selectedScheduleTypeId === scheduleType.id ? 'checked' : ''} ${styles.option}`}
            onClick={onScheduleTypeClick}
            data-testid={dataTestId}
        >
            <label>
                <div className="radio-button-check"><Img src="/img/icons/checkmark-icon.svg" /></div>
                <div className="radio-button-label">
                    <div className={styles.label} data-testid={dataTestId && `${dataTestId}.label`}>
                        {scheduleType.label}
                    </div>
                    {scheduleType.description && (
                        <>
                            <div className={`${styles.description} mt8`} data-testid={dataTestId && `${dataTestId}.description`}>
                                {scheduleType.description}
                            </div>
                            {scheduleType.link && (
                                <div className={`${styles.description} mt8`} data-testid={dataTestId && `${dataTestId}.link-desc`}>
                                    {scheduleType.linkDescription}
                                    <a target="_blank" rel="noopener noreferrer" href={scheduleType.link} onClick={e => e.stopPropagation()} data-testid={dataTestId && `${dataTestId}.learn-more-link`}> here</a>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </label>
        </div>
    );
};

ScheduleTypeOption.propTypes = {
    selectedScheduleTypeId: PropTypes.number,
    scheduleType: PropTypes.objectOf(any).isRequired,
    handleScheduleTypeClick: PropTypes.func.isRequired,
    'data-testid': PropTypes.string,
};

ScheduleTypeOption.defaultProps = {
    selectedScheduleTypeId: null,
    'data-testid': undefined,
};

export default ScheduleTypeOption;
